<mat-card class="overview-card">
	<mat-card-header class="overview-card-header">
		<h5 class="text-center font-weight-bold ma-1">
			{{ jobTitle.name }} ({{ jobTitle.abbreviation }})
			<span class="readonly-label"></span>
		</h5>
	</mat-card-header>
	<mat-card-content class="card-content no-padding ">
		<div class="job-details">
			<div class="readonly-label">
				Created: <span class="data">{{ jobTitle.effectiveStart | date: 'MMMM, y' }}</span>
			</div>
			<div class="end-date readonly-label">
				Archived:
				<span class="data">{{
					jobTitle.effectiveEnd ? (jobTitle.effectiveEnd | date: 'MMMM, y') : 'None'
				}}</span>
			</div>
		</div>
	</mat-card-content>
	<mat-card-actions class="card-action-box">
		<button
			type="button"
			color="primary"
			mat-button
			(click)="navigate(jobTitle.jobTitleId)"
			*ngIf="!this.isArchived"
		>
			Edit
		</button>
		<button
			type="button"
			color="primary"
			mat-button
			(click)="navigateArchived(jobTitle.jobTitleId)"
			*ngIf="isArchived"
		>
			View
		</button>
	</mat-card-actions>
</mat-card>
